<script>
  import Textfield from '@smui/textfield';
  import HelperText from '@smui/textfield/helper-text';
  import Button, { Label } from '@smui/button';
  import { createForm } from "svelte-forms-lib";
  import { basicData as schema } from './schemas.js';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let fields = {
    email:        '',
    phone:        ''
  };


  const { form, errors, handleSubmit, validateField } = createForm({
    initialValues: {...fields},
    validationSchema: schema,
    onSubmit: values => {
      fields = values;
      dispatch('done');
    }
  });

</script>

<form on:submit={handleSubmit}>
  <div class="row row-m1">
    <div class="cell">
      <Textfield bind:value={$form.email}
        variant="outlined"
        type="email"
        label="E-mail"
        input$autocomplete="email"
        invalid={$errors.email}
        on:keyup={() => validateField('email')}>
        <HelperText persistent slot="helper" invalid>{$errors.email}</HelperText>
      </Textfield>
    </div>
    <div class="cell">
      <Textfield bind:value={$form.phone}
        variant="outlined"
        label="Telefon"
        invalid={$errors.phone}
        input$autocomplete="tel"
        on:keyup={() => validateField('phone')}>
        <HelperText persistent slot="helper" invalid>{$errors.phone}</HelperText>
      </Textfield>
    </div>
  </div>

  <Button type="submit" variant="raised">
    <Label>Dalej</Label>
  </Button>
</form>
